// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IGetTasksRequestModel {
    static getAttributeTypeMap() {
        return IGetTasksRequestModel.attributeTypeMap;
    }
}
IGetTasksRequestModel.discriminator = undefined;
IGetTasksRequestModel.additionalProperties = false;
IGetTasksRequestModel.attributeTypeMap = [
    {
        "name": "typeId",
        "baseName": "typeId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
];
//# sourceMappingURL=iGetTasksRequestModel.js.map